module.exports = __webpack_public_path__ + "img/placeholder-es.f12118af.jpg";